export { wrapPageElement } from "./src/wrap-page-element"
